import React from 'react';

import { Button, SidePage, Stack } from '@gogame/components';
import {
  ClearFiltersButton,
  ApplyFiltersButton,
  CompareFilters,
  EqualizeFilters,
  useFiltersStateManager,
  useFiltersFieldsManagerContext,
} from '@gogame/filters';

const AllFilters = ({
  children,
  title = 'Filters',
  tabs = null,
  open,
  onClose,
  onExited,
  withEqualize,
  applyButton = <ApplyFiltersButton />,
  dense = false,
  withClearFilters = true,
}) => {
  const { collection } = useFiltersStateManager();
  const { compared } = useFiltersFieldsManagerContext();

  return (
    <SidePage
      open={open}
      onClose={onClose}
      onExited={onExited}
      data-cy={'filtersSidepage'}
      width={916}
    >
      <SidePage.Title
        title={title}
        actions={
          <React.Fragment>
            {collection ? <CompareFilters /> : null}
            {withEqualize ? <EqualizeFilters disabled={!compared} /> : null}
          </React.Fragment>
        }
      >
        {tabs ? tabs : null}
      </SidePage.Title>
      <SidePage.NewBody dense={dense}>{children}</SidePage.NewBody>
      <SidePage.Actions>
        <Stack flex={1} justifyContent={'space-between'} direction={'row'}>
          <Button onClick={onClose}>Close</Button>
          <Stack spacing={2} direction={'row'}>
            {withClearFilters ? <ClearFiltersButton /> : null}
            {React.cloneElement(applyButton, { onClick: onClose })}
          </Stack>
        </Stack>
      </SidePage.Actions>
    </SidePage>
  );
};
export default AllFilters;
